"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
exports.brandColors = {
    green: '#5CB335',
};
// Copied from components/icons
var Icon = styled_components_1.default.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
Icon.defaultProps = {
    width: '1em',
    height: '1em',
    viewBox: '0 0 32 32',
    fill: '#d8d8db',
};
var CheckboxCheckedIcon = function (props) { return (react_1.default.createElement(Icon, __assign({}, props, { viewBox: "0 0  24 24" }),
    react_1.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
    react_1.default.createElement("path", { d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" }))); };
exports.Wrapper = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: relative;\n\toutline: none;\n\tbackground: none;\n"], ["\n\tposition: relative;\n\toutline: none;\n\tbackground: none;\n"])));
exports.StyledCheckboxCheckedIcon = styled_components_1.default(CheckboxCheckedIcon)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tfill: ", ";\n"], ["\n\tfill: ", ";\n"])), exports.brandColors.green);
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=styles.js.map